export const STEP_STATUSES = {
  COMPLETED: 'completed',
  CURRENT: 'current',
  PENDING: 'pending',
};
